export const checkScreen = (width) => {
	if (width > 768) return 20;
	return 24;
};
